<template>

  <!-- Mirrored from html.physcode.com/travel/home-2.html by HTTrack Website Copier/3.x [XR&CO'2014], Tue, 11 Feb 2020 16:05:20 GMT -->

  <!-- Mirrored from html.physcode.com/travel/home-2.html by HTTrack Website Copier/3.x [XR&CO'2014], Tue, 11 Feb 2020 16:05:20 GMT -->

  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>County Bill</title>
    <link rel="shortcut icon" href="images/favicon.png" type="image/x-icon">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Yellowtail&display=swap" rel="stylesheet">
  </head>

  <body
      style="padding: 0px; margin: 0px; font-family: 'Montserrat', sans-serif; background-color: #a2a2a21c;box-sizing: border-box;">

  <button class="print-btn" onclick="window.print()"><img src="assets/printer.svg" alt="Printer Icon"></button>
  <button class="print-btn email-doc" title="send On Email"><img src="assets/email-icon.png" alt="Printer Icon "></button>

  <page class="page" style="width: 210mm; min-height:297mm; display: flex; position: relative; flex-flow: column; background-color: white;">
    <!-- main content -->
    <div style="padding: 8.5mm;">

      <header style="display: flex; height: auto; min-height: 30mm; align-items: center; position: relative; width: 100%; justify-content: space-between; padding-bottom: 2mm;">
        <div>
          <img :src="county.stateLogo" style="height: 30mm; margin-right: 0mm;">
        </div>
        <div style="text-align: center; margin-right: 8.5mm; margin-left: 8.5mm;">
          <h2 style="
                        margin-top: 0px;
                        font-size: 20px;
                        text-transform: uppercase;
                        color: #4ca82c;
                        font-weight: 700;
                        margin-bottom: 1.2mm;
                        padding-bottom: 0px;

                    ">
            County Government <br> Of {{county.countyName}}
          </h2>

          <h5 style="padding: 0px;
                    margin: 0px;
                    font-size: 15px;
                    font-weight: bold; text-transform: uppercase; margin-bottom: 4.5mm;">
            ({{billDetails.subCountyName}} {{billDetails.wardName}} {{billDetails.zone}})
          </h5>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 10px;
                    font-weight: 400;">
            {{county.address}} <br>
            Email: {{county.email}}
          </h4>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 10px;
                    font-weight: 400;
                    font-style: italic;
                    font-family: 'Times New Roman', Times, serif;
                    margin-top: 2mm;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 5mm;
                    flex-wrap: wrap;">
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif;">{{county.headline}}</span>
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif;">—</span>
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif;">{{county.tagline2}}</span>
          </h4>

        </div>
        <div>
          <img :src="county.logo" style="height: 30mm; margin-right: 0mm;">
        </div>

      </header>

      <div style="margin-top: 3mm;">
        <img src="assets/blue-line.png" style="width: 100%;">
      </div>

      <!-- contact information and QR code -->
      <div style="display: flex; justify-content: space-between;">

        <!-- contact information -->
        <div style="font-size: 12px; flex: 1; max-width: calc(100% - 30mm);">

          <p style="padding: 0px; margin: 0px; padding-top: 4.3mm; padding-bottom: 1.5mm;">
            Issued To: <strong>{{ billDetails.customerName || billDetails.description }}</strong>
          </p>

          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm;">Date of Creation: <strong style="text-transform:uppercase;">{{formatDate(billDetails.dateCreated)}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm;">Invoice No. <strong style="text-transform:uppercase;">{{billDetails.billNo}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm; margin-top:1.5mm;">Printed On. <strong style="text-transform:uppercase;">{{getCurrentDateTime()}}</strong></p>

        </div>

        <!-- the qr code -->
        <div style="height: 25.3mm; margin-top: 3.3mm; width: 25.3mm; min-width: 25.3mm; border: 2px solid #0045a1; display: flex; justify-content: center; align-items: center;">
          <img :src="link" style="height: 25mm;">
        </div>

      </div>

      <!-- Description section with proper wrapping -->
      <div style="margin-top: 2mm; margin-bottom: 2mm; max-width: 100%; overflow: hidden;">
        <small style="display: block; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; white-space: normal; line-height: 1.4; font-size: 11px;">
          <!--          <strong>{{billDetails.description}}</strong>-->
        </small>
      </div>

      <!-- the table -->
      <table style="margin-top: 4mm; border-spacing: initial; min-height: 70mm; width: 100%; table-layout: fixed;">
        <thead class="" style="text-transform: uppercase;
                font-weight: 700;
                font-size: 12px;
                background: #e2f2fd;
                padding: 2.5mm;">
        <tr>
          <td style="padding: 2.9mm; width: 10mm; font-size: 10px"></td>
          <td style="padding: 2.5mm;">Fee Description</td>
          <td style="text-align: right; padding: 2.5mm; width: 35mm;">Amount</td>
        </tr>
        </thead>
        <tbody style="font-size: 12px;">
        <tr v-for="(item, index) in billInfo" :key="`item-${index}`">
          <td style="padding: 2.5mm; border-bottom: 1px solid #80808029; vertical-align: top;">{{index+1}}.</td>
          <td style="padding: 2.5mm; border-bottom: 1px solid #80808029; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word;">
            <p style="margin: 0px; padding: 0px;">{{item.feeDescription}}</p>
            <strong style="">{{maskPhoneNumber(item.customer)}}</strong>
            <br v-if="item.description">
            <small style="display: block; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; white-space: normal; line-height: 1.3;">{{item.description}}</small>
          </td>
          <td style="text-align: right; padding: 2.5mm; border-bottom: 1px solid #80808029; padding-top: 2.5mm; vertical-align: top;">
            <strong>KES {{numberFormat(item.billTotal)}}</strong>
          </td>
        </tr>
        </tbody>
      </table>

      <div>
        <img src="assets/blue-line.png" style="width: 100%; margin-bottom: 0mm;">
      </div>

      <!-- billing details and summary -->
      <div class="" style="display:flex; text-transform: uppercase; justify-content:flex-end;">
        <div>
          <table style=" margin-top:3.3mm; border-spacing: inherit; text-transform: capitalize; font-size: 14px;">
            <tbody>
            <tr>
              <td style="padding: 2.5mm; border-bottom: 1px solid #d9d9d9;">Amount Billed:</td>
              <td style="text-align: right; padding: 2.5mm; border-bottom: 1px solid #d9d9d9;"><strong>KES {{numberFormat(billDetails.detailAmount)}}</strong></td>
            </tr>

            <tr>
              <td style="padding: 2.5mm; border-bottom: 1px solid #d9d9d9;">Amount Paid</td>
              <td style="text-align: right; padding: 2.5mm; border-bottom: 1px solid #d9d9d9;"><strong>KES {{numberFormat(billDetails.receiptAmount)}}</strong></td>
            </tr>

            <tr>
              <td style="padding: 2.5mm;">Payable Balance:</td>
              <td style="text-align: right; padding: 2.5mm;"> <strong>KES {{numberFormat(billDetails.billBalance)}}</strong></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- the footer starts here -->
    <div style="padding: 8.5mm; width: 100%; background-color: #e2f2fd; flex-grow: 1; margin-top: 0mm; display: flex; flex-flow: column; justify-content: space-between;">

      <!-- Payment Options Section -->
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <div style="font-size: 12px; padding-top: 3.3mm;">
          <h2 style="
                      margin-top: 0px;
                      font-size: 18px;
                      text-transform: uppercase;
                      color: #0045a1;
                      font-weight: 700;
                      margin-bottom: 3.3mm;
                      padding-bottom: 0px;
                  ">
            Payment Options
          </h2>
          <p style="margin: 0; padding: 0;"><strong>MPESA</strong></p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1mm;">Pay Bill No. <strong>{{payBill?.shortCode || '-'}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1mm;">Account Name <strong>{{billDetails.billNo}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1mm;">Amount <strong>KES {{numberFormat(billDetails.detailAmount)}}</strong></p>

          <p style="padding-top: 1mm; margin: 0;"><strong>BANK</strong></p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm;">Bank <strong>{{bank?.bank || '-'}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1mm;">Amount <strong>KES {{numberFormat(billDetails.detailAmount)}}</strong></p>
        </div>

        <!-- android logo (hidden) -->
        <div style="padding-top: 3.3mm; padding-left: 17.3mm; display: none;">
          <div style="display: flex; margin-bottom: 4mm; justify-content: center; align-items: center;">
            <img src="assets/android-logo.svg" style="margin-right: 3.3mm; height: 12mm;">
            <span style="font-family: 'Yellowtail', cursive; color: #0045a1; line-height: 0.9; font-size: 20px;">Scan to download the <br>Android App.</span>
          </div>

          <div style="position: relative; display: none;">
            <img src="assets/code-demo.png" style="height: 16.6mm; margin: 1.25mm;">
            <img src="assets/camera-frame.svg" style="position: absolute; left: 0; height: 18.6mm;">
            <img src="assets/curved-arrow.svg" style="height: 13mm; margin-left: 4mm; display: none;">
          </div>
        </div>
      </div>

      <!-- Footer Bottom Section -->
      <footer style="width: 100%; margin-top: auto;">
        <!-- Thank You and Blue Line -->
        <div style="display: flex; flex-flow: column;">
          <span style="font-family: 'Yellowtail', cursive; color: #0045a1; line-height: 0.9; font-size: 20px; text-align: right;">Thank You!</span>
          <img src="assets/blue-line.png" style="width: 100%;">
        </div>

        <!-- Served By and Invoice Row -->
        <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 2mm; flex-wrap: wrap; gap: 2mm;">
          <p style="padding: 0; margin: 0; font-size: 12px;">
            Served By <strong>{{billDetails.names}}</strong>
          </p>
          <p style="padding: 0; margin: 0; font-size: 12px;">
            <strong>INVOICE NO. {{billDetails.billNo}}</strong>
          </p>
        </div>

        <!-- Powered By and Tagline Row -->
        <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 2mm; flex-wrap: wrap; gap: 2mm; padding-bottom: 5mm;">
          <p v-if="county.powered" style="margin: 0; font-size: 11px; color: #333;">
            {{county.powered}}
          </p>
          <p v-if="county.tagline2" style="margin: 0; font-size: 11px; font-style: italic; color: #333;">
            {{county.tagline2}}
          </p>
        </div>
      </footer>

    </div>
  </page>

  </body>


</template>

<style scoped>
* {
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
  -webkit-print-color-adjust: exact !important;
  /* Chrome, Safari */
  color-adjust: exact !important;
  /*Firefox*/
}

.print-btn {
  display: flex;
  z-index: 1000000000;
  position: fixed;
  background: #4aaa23;
  color: white;
  top: 30px;
  right: 30px;
  border-radius: 50%;
  padding: 1rem;
  margin: 0px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 0px 20px 4px rgb(136 136 136 / 65%);
  cursor: pointer;
  transition: 0.4s;
}
.email-doc{
  top: 130px;
  background: #0063c0;
}

.print-btn img {
  height: 35px;
}

/* Table layout fix for text wrapping */
table {
  table-layout: fixed;
  width: 100%;
}

table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

@media print {
  .print-btn {
    display: none;
  }
  body {
    margin: 0px !important;
    padding: 0px !important;
    background-color: white;
  }
  @page {
    /* size: auto; */
    /* auto is the initial value */
    /* this affects the margin in the printer settings */
    /* width: 210mm;*/
    /* height: 297mm; */
    size: A4 portrait;
    margin: 0px;
    margin-bottom: 0px;
    margin: 0px;
  }
}

@page {
  /* size: auto; */
  /* auto is the initial value */
  /* this affects the margin in the printer settings */
  /* width: 210mm;
      height: 297mm; */
  size: A4 portrait;
  margin: 0px;
  margin-bottom: 0px;
  margin: 0px;
}
</style>


<script>
/* eslint-disable */
import {execute, biller, authUrl} from "@/api";
import dayjs from 'dayjs';

export default {
  name: "PrintBill",
  data() {
    return {
      date: null,
      link:'',
      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline: null,
        smsusername: null,
        smspassword:null,
        contact: null,
        center: null,
        address: null,
        email: null,
        headline: null,
        tagline2: null,
        ussd: null,
        logo: null,
        bank: null,
        powered: null,
        stateLogo: null,
        QRLink: null,
        selfService: null
      },
      customer: {
        id: 1,
        names: null,
        phoneNumber: null,
        email: null,
        createdBy: null,
        dateCreated: null
      },
      bank: null,
      payBill: null,
      billDetails: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription:null,
        costCenterNo: null,
        accountNo:null ,
        description: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        status: null,
        dateCreated: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        category:null,
        incomeTypePrefix: null,
        customerName: null
      },
      billInfo: [
        {
          id: null,
          billNo: null,
          feeID: null,
          feeDescription: null,
          fiscalYear: null,
          paymentCode: null,
          customer: null,
          description: null,
          periodID: null,
          wardID: null,
          subCountyID: null,
          subCountyName: null,
          wardName: null,
          createdBy: null,
          billTotal: null,
          receiptAmount: null,
          billBalance: null,
          status: null,
          dateCreated:null,
          zone: null,
          departmentID: null,
          department: null,
          idNo: null,
          phoneNumber: null,
          names: null,
          customerPhoneNumber: null,
          category: null,
          incomeTypePrefix: null
        }
      ]
    };
  },
  mounted() {
    this.initializeData();
  },

  watch: {
    // Watch for route changes to handle navigation with different bill numbers
    '$route.params.billNo': {
      handler(newBillNo) {
        if (newBillNo) {
          this.getBill(newBillNo);
        }
      },
      immediate: false
    }
  },

  methods: {

    async initializeData() {
      // First load county data
      await this.getCounty();
      // Then check URL params and load bill
      this.checkUrlParams();
      this.menuAccess();
    },

    async getCounty() {
      try {
        const data = new FormData();
        data.append("function", "getCounty");
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.county = res.data.data.county;
        }
      } catch (e) {
        console.error(e);
      }
    },

    checkUrlParams() {
      // Check for route params first (e.g., /bill/PKN042802303369)
      const routeBillNo = this.$route.params.billNo;

      // Then check for query params (e.g., /bill?billNo=PKN042802303369)
      const urlParams = new URLSearchParams(window.location.search);
      const queryBillNo = urlParams.get('billNo') || urlParams.get('invoice');

      // Then check localStorage as fallback
      let localStorageBillNo = null;
      try {
        const params = JSON.parse(localStorage['params']);
        localStorageBillNo = params.billNo;
      } catch (error) {
        // ignore
      }

      // Route params take priority, then query params, then localStorage
      const billNo = routeBillNo || queryBillNo || localStorageBillNo;

      if (billNo) {
        console.log('####' + billNo);
        this.getBill(billNo);
      }
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input; // Return as is if input is null, undefined, or not a string
      }

      // Remove all non-digit characters
      const digits = input.replace(/\D/g, '');

      // Check if the number has a valid length for a phone number (e.g., 10 digits)
      if (digits.length === 10) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      // Return as is if not a phone number or if the length is incorrect
      return input;
    },


    menuAccess(){

      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {
            // alert(res.data.message);
          })
          .catch(() => {
            // alert(e.message);
          });

    },
    getCurrentDateTime() {
// Create a new Date object with the current date and time
      const now = new Date();
// Format the date and time as DD MMM YYYY hh:mm:ss
      const formattedDateTime = now.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });
// Return the formatted date and time
      return formattedDateTime;
    },
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },
    formatDate(dateString) {
// Parse the date string with the original format
      const date = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss');
// Format the date with the desired format
      return date.format('DD MMM YYYY [AT] hh:mm A');
    },
    showDate() {
      const dateObj = new Date();
      const currentDate =
          dateObj.getDate() +
          "/" +
          dateObj.getMonth() +
          "/" +
          dateObj.getFullYear();
      return currentDate;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getBill(billNo) {
      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {

              /* if (!res.data.data.billDetails.customerName) {
                 alert('The invoice cannot be printed because Customer Name is missing.');
                 window.location.replace('/#/new-bill'); // Redirects to the homepage or any other page
                 return;
               }*/

              if (res.data.data.billDetails.printable ==='false') {
                alert('The invoice is not ready for printing as it has not been approved yet. Please check back later or contact support for assistance.');
                window.location.replace('/#/new-bill'); // Redirects to a relevant page
                return;
              }

              this.county = res.data.data.county
              this.payBill = res.data.data.payBill
              if(res.data.data.customer!==null)
                this.customer = res.data.data.customer
              this.billDetails = res.data.data.billDetails;
              this.billInfo = res.data.data.billInfo;
              this.bank = res.data.data.bank

              // Generate QR code linking to payment page using selfService URL
              const baseUrl = this.county.selfService || window.location.origin;
              const qrBaseUrl = this.county.QRLink || 'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=';
              const paymentUrl = baseUrl + '/#/payment/' + this.billDetails.billNo;
              this.link = qrBaseUrl + encodeURIComponent(paymentUrl);

            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
  },
};
</script>